import React, { useEffect, useRef } from "react";

import BillContent from "./BillContent";

const GenerateBill = () => {
  const order = JSON.parse(localStorage.getItem("order"));
  const componentRef = useRef();

  useEffect(() => {
    const timer = setTimeout(() => window.print(), 500);
    return () => clearTimeout(timer);
  }, []);

  if (!order) return null;

  return (
    <div ref={componentRef} style={{ padding: 16 }}>
      <BillContent order={order} />
    </div>
  );
};

export default GenerateBill;
